import { useRoute, useLocation } from "wouter";
import { DocsLayout } from "@/site-kit/components/docs";
import { docGroups, allSections } from "./docs-content";

const logo = (
  <span className="font-semibold text-lg tracking-tight">
    <span className="bg-gradient-to-r from-blue-600 to-violet-600 bg-clip-text text-transparent">
      AI Apps
    </span>
  </span>
);

const navLinks = [
  { href: "/docs", label: "Docs" },
  {
    href: "https://www.npmjs.com/package/aiapps",
    label: "npm",
    external: true,
  },
  { href: "https://github.com", label: "GitHub", external: true },
];

export function DocsPage() {
  const [, params] = useRoute("/docs/:section");
  const [, navigate] = useLocation();

  const sectionId = params?.section || allSections[0]?.id || "introduction";
  const validSection = allSections.find((s) => s.id === sectionId);
  const activeSectionId = validSection
    ? sectionId
    : allSections[0]?.id || "introduction";

  return (
    <DocsLayout
      docGroups={docGroups}
      docSections={allSections}
      activeSectionId={activeSectionId}
      onSectionChange={(id) => navigate(`/docs/${id}`)}
      logo={logo}
      productName="AI Apps"
      siteBaseUrl="https://aiapps.build"
      navbarProps={{ navLinks }}
    />
  );
}
